/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ created: NonNullable<unknown>, updated: NonNullable<unknown>, failed: NonNullable<unknown> }} Import_Commit_PartialInputs */

const cs_import_commit_partial = /** @type {(inputs: Import_Commit_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import dokončen s chybami. Vytvořeno: ${i?.created}, aktualizováno: ${i?.updated}, selhalo: ${i?.failed}.`)
};

const en_import_commit_partial = /** @type {(inputs: Import_Commit_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import partially completed. Created: ${i?.created}, updated: ${i?.updated}, failed: ${i?.failed}.`)
};

/**
* | output |
* | --- |
* | "Import partially completed. Created: {created}, updated: {updated}, failed: {failed}." |
*
* @param {Import_Commit_PartialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_commit_partial = /** @type {((inputs: Import_Commit_PartialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Commit_PartialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_commit_partial(inputs)
	return cs_import_commit_partial(inputs)
});